export default "__VITE_ASSET__WlB8Wq6U__"